/**
 * Entry point for the vendor-management-internal SPA.
 *
 * Standalone React 18 + Mantine app. No Remix, no SSR. Mantine's stylesheet
 * is the source of truth for the base reset; `styles/global.css` only owns
 * app-wide layout invariants. Client-side routing is TanStack Router (VI-513) —
 * the provider tree + AppShell chrome live in the root route (App); this file
 * just mounts the router.
 */
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles/global.css';

import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';

function main(): void {
    const rootElement = document.querySelector('#root');
    if (!rootElement) {
        throw new Error('Root element #root not found in index.html');
    }
    createRoot(rootElement).render(<RouterProvider router={router} />);
}

main();
